/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Grid,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  tabHighLigther,
  autoFormateDate,
  toQtrToDT,
  fromQtrToDT,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import {
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  dispatchQtrRange,
  dispatchErrorMsgUnit,
  dispatchPerformResolutionObj,
  getPlanTypeValues,
  getRebateProgrameList,
  dispatchRebateProgramName,
  dispatchSearchScreen,
  getAllRebateProgram,
  getNdcGridData,
  dispatchNdcGridData,
  dispatchAllRebateValue,
  dispatchDisplayObjAdjustment,
} from '../Store/action';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  BEGIN_DATE,
  DATE_RANGE_INVALID,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { compareDate } from '../../../../SharedModules/utilities/dateUtilities';
import {
    validateDateQuarter,
  } from '../../../../SharedModules/utilities/utilities'; // add if not already
  import {
    FROM_DATE_QTR_REQUIRED,
    TO_DATE_QTR_REQUIRED,
  } from '../../../../SharedModules/Errors/constantMessageData'; // add if not already
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
const normalizeQuarterPattern = (val = '') => {
    let v = val.trim().toUpperCase();
    let m = v.match(/^(20\d{2})Q([1-4])$/);
    if (m) return `${m[2]}Q${m[1]}`;
    m = v.match(/^Q([1-4])(20\d{2})$/);
    if (m) return `${m[1]}Q${m[2]}`;
    return v;
  };
  
  const toConcreteDateIfQuarter = (val, isEnd = false) => {
    if (!val) return val;
    const norm = normalizeQuarterPattern(val);
    if (/^[1-4]Q20\d{2}$/.test(norm)) {
      return isEnd ? toQtrToDT(norm) : fromQtrToDT(norm);
    }
    return val;
  };
  const ensureFullYearQuarter = (q) => {
      if (/^[1-4]Q\d{2}$/.test(q)) return autoFormateDate(q); // expands to 1Q2024
      return q;
    };
    
    const isQuarterToken = (v) => /^[1-4]Q(\d{2}|\d{4})$/.test(v);

const UnitAdjustment = (props) => {
  // use Selector function
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    selectedPlanType,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgUnit: getErrorMsg,
    quarterFrom: getQuarter,
    selectReportValue,

    fromDateValue,
    endDateValue,
    adjustmentTypeValue,
    allRebateProgram: allRebateProgramValue,
    allRebate,
    gridData,
    isLoading,
  } = useSelector((state) => state?.sharedState?.AdjustmentReducer);

  // const spinnerLoader = useSelector((state) => {
  //   return state?.sharedState.showPreLoader?.showPreLoader;
  // });
  const dispatch = useDispatch();
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [endDate, setEndDate] = React.useState(endDateValue);
  const [startQtr, setStartQtr] = React.useState(getQuarter);
  const [reportSelection, setReportSelection] =
    React.useState(selectReportValue);
  const [adjustmentType, setAdjustmentType] =
    React.useState(adjustmentTypeValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [rebateList, setRebateList] = React.useState([]);
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          startQtr: '',
          fromDate: '',
        }
  );
  // date validator
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  const dateRegex1 = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{2}$/;

  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));
 
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  const onClickOnSearch = async () => {
      let rebateProgramNameValue = rebateList?.map((obj) => obj.rebateProgramCd);
      const rebateProgramName = rebateProgramList?.find(
        (item) => item.id === state?.rebateProgramCd
      );
    
      if (!rebateProgramNameValue) {
        const obj = [{ rebateProgramCd: rebateProgramList[0]?.id }];
        rebateProgramNameValue = obj?.map((x) => x.rebateProgramCd);
      }
    
      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => {
        return (
          (reportSelection !== 'Paid Quarter' || item.field !== 'startQtr') &&
          (reportSelection !== 'Adjustment Type/Dates' || item.field !== 'fromDate') &&
          (state.rebateProgramCd !== '-1' || item.field !== 'rebateProgramCd') &&
          item.field !== 'nomanufacture'
        );
      });
      if (reportSelection === 'Paid Quarter' && !startQtr) {
        localErr.push({
          field: 'startQtr',
          errorType: 'startQtrRequired',
          message: QUARTER_VALUE_REQUIRED,
        });
      } else if (reportSelection === 'Adjustment Type/Dates' && !fromDate) {
        localErr.push({
          field: 'fromDate',
          errorType: 'required',
          message: BEGIN_DATE,
        });
      } else if (state.rebateProgramCd === '-1' && !allRebateProgram) {
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: REBATE_PROGRAM_REQUIRED,
        });
      }
      const dedup = [];
      const seen = new Set();
      localErr.forEach((e) => {
        const k = `${e.field}|${e.message}`;
        if (!seen.has(k)) {
          seen.add(k);
          dedup.push(e);
        }
      });
      dispatch(dispatchErrorMsgUnit(dedup));
    
      if (dedup.length > 0) return;
      const rawEnd = endDate || fromDate;
      let effectiveFrom = fromDate;
      let effectiveTo = rawEnd;
      if (reportSelection === 'Adjustment Type/Dates') {
        let normFrom = normalizeQuarterPattern(fromDate);
        let normTo = normalizeQuarterPattern(rawEnd);
        normFrom = ensureFullYearQuarter(normFrom);
        normTo = ensureFullYearQuarter(normTo);
        effectiveFrom = isQuarterToken(normFrom) ? fromQtrToDT(normFrom) : normFrom;
        effectiveTo = isQuarterToken(normTo) ? toQtrToDT(normTo) : normTo;
      }
      dispatch(dispatchNdcGridData([]));
      setSearchClicked(true);
      let requestData = {
        rebateProgramCd: allRebateProgram
          ? rebateProgramNameValue[0]
          : rebateProgramName?.rebateProgramCd,
        aiAllRpc: allRebateProgram ? 1 : 0,
      };
    
      if (reportSelection === 'Paid Quarter') {
        requestData.paidQtr = startQtr;
      } else if (reportSelection === 'Adjustment Type/Dates') {
        requestData.startDate = effectiveFrom;
        requestData.endDate = effectiveTo;
        requestData.adjustmentTyep = adjustmentType;
      }
    
      const rebateProgramObj = {
        rebateProgramName: rebateProgramName?.name?.toString()?.replace('|', '-'),
        rebateProgramCd: state?.rebateProgramCd,
      };
    
      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchQtrRange(startQtr));
      dispatch(
        dispatchSearchScreen({
          selectReportValue: reportSelection,
          fromDateValue: fromDate,
          endDateValue: rawEnd,
          adjustmentTypeValue: adjustmentType,
          allRebateProgram,
          allRebateProgramValue,
        })
      );
    
      // Service call with converted dates
      const result = await dispatch(
        getAllRebateProgram({
          rebateProgramCd: allRebateProgram ? null : state.rebateProgramCd,
          aiAllRpc: allRebateProgram ? 1 : 0,
          startDate: requestData.startDate || (reportSelection === 'Paid Quarter' ? undefined : effectiveFrom),
          endDate: requestData.endDate || (reportSelection === 'Paid Quarter' ? undefined : effectiveTo),
          paidQtr: reportSelection === 'Paid Quarter' ? startQtr : undefined,
          adjustmentTyep: reportSelection === 'Adjustment Type/Dates' ? adjustmentType : undefined,
        })
      );
    
      if (result?.payload?.unitAdjustmentsNDCLevelHeaderReportVO?.length > 0) {
        requestData = {
          ...requestData,
          rebateProgramCd:
            result?.payload?.unitAdjustmentsNDCLevelHeaderReportVO?.[0]?.rebateProgramCd,
        };
      }
    
      dispatch(
        dispatchDisplayObjAdjustment({
          rebateProgramName,
          quarterFrom: startQtr,
          allRebateValue: allRebateProgram
            ? result?.payload?.unitAdjustmentsNDCLevelHeaderReportVO || []
            : [{ ...rebateProgramObj }],
          selectReportValue: reportSelection,
          fromDateValue: fromDate,
          endDateValue: rawEnd,
          adjustmentTypeValue: adjustmentType,
          allRebateProgram,
          allRebateProgramValue,
        })
      );
    
      console.log('UnitAdjustment search payload:', requestData);
    
      dispatch(getNdcGridData(requestData));
    }; 
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          disabled: allRebateProgram,
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgUnit(unique));
  };
  const [ValidatedStartQtr, setValidatedStartQtr] = useState();
  const validateStartQuarterOnly = (type, data, from) => {
    let localErr = [];

    const value = from === 'fromUseEffect' ? data : autoFormateDate(data);

    if (data && !_.isEmpty(data) && !_.isNaN(data)) {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'startQtr',

            errorType: 'startQtrRequired',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }

      if (quarterTest1.test(data) || quarterTest2.test(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'startQtr',

              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }

        localErr = localErr.filter((item) => item.field !== 'startQtr');

        setStartQtr(value?.toUpperCase());
      } else {
        localErr = localErr.filter((item) => item.field !== 'startQtr');

        localErr.push({
          field: 'startQtr',

          errorType: 'invalidFormat',

          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr.filter((item) => item.field !== 'startQtr');

      if (type === 'startQtr') {
        localErr.push({
          field: 'startQtr',

          errorType: 'startQtrRequired',

          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }

    return localErr;
  };
  const handleOnblurEvent = (type, rawVal) => {
      let localErr = [...(getErrorMsg || [])];
    
      const upper = (v) => (v || '').toUpperCase().trim();
    
      const removeFields = (...fields) => {
        fields.forEach(f => {
          localErr = localErr.filter(e => e.field !== f);
        });
      };
      const normalizeQuarterToken = (val) => {
        if (!val) return val;
        let v = upper(val).replace(/\s+/g, '');
        let m = v.match(/^(20\d{2})Q([1-4])$/);
        if (m) return `${m[2]}Q${m[1]}`;
        m = v.match(/^Q([1-4])(20\d{2})$/);
        if (m) return `${m[1]}Q${m[2]}`;
        return v;
      };
      const isQuarterToken = (v) => /^[1-4]Q(20)?\d{2}$/.test(v);
      if (type === 'startQtr') {
        const data = autoFormateDate(rawVal);
        const startQtrError = validateStartQuarterOnly(type, data);
        removeFields('startQtr');
        localErr = [...localErr, ...startQtrError];
      }
    
      if (type === 'rebateProgramCd') {
        removeFields('rebateProgramCd');
      }
    
      if (type === 'fromDate' || type === 'endDate') {
        const isFrom = type === 'fromDate';
        let value = upper(rawVal);
    
       
        value = normalizeQuarterToken(value);
        if (/^[0-9/]+$/.test(value) || /^[1-4]Q\d{2}$/.test(value)) {
          value = autoFormateDate(value);
        }
    
        if (isFrom) setFromDate(value);
        else setEndDate(value);
    
  
        removeFields(isFrom ? 'fromDate' : 'endDate', 'fromDate>endDate');
    
        if (!value) {
          localErr.push({
            field: isFrom ? 'fromDate' : 'endDate',
            message: isFrom ? FROM_DATE_QTR_REQUIRED : TO_DATE_QTR_REQUIRED
          });
        } else {
          const validatorKey = isFrom ? 'fromDate' : 'toDate';

          const validateTarget = value;
    
          let vErr = validateDateQuarter(validateTarget, validatorKey) || [];
    
          
          vErr = vErr.map(er => er.field === 'toDate' ? { ...er, field: 'endDate' } : er);
    
          localErr = [...localErr, ...vErr];
    
         
          if (isFrom && vErr.length === 0 && (!endDate || !endDate.trim())) {
            setEndDate(value);
          }
        }
    
        // Ordering check (only if both present and individual validations passed)
        const prospectiveFrom = isFrom ? value : fromDate;
        const prospectiveEnd = !isFrom ? value : endDate;
    
        const hasFromErr = localErr.some(e => e.field === 'fromDate');
        const hasEndErr = localErr.some(e => e.field === 'endDate');
    
        if (prospectiveFrom && prospectiveEnd && !hasFromErr && !hasEndErr) {
          removeFields('fromDate>endDate');
    
          // Convert quarters to real MM/DD/YYYY using existing utilities
          const concreteFrom = isQuarterToken(prospectiveFrom)
            ? fromQtrToDT(normalizeQuarterToken(prospectiveFrom).replace(/^([1-4]Q)(\d{2})$/, (_, p1, y) => `${p1}20${y}`))
            : prospectiveFrom;
    
          const concreteEnd = isQuarterToken(prospectiveEnd)
            ? toQtrToDT(normalizeQuarterToken(prospectiveEnd).replace(/^([1-4]Q)(\d{2})$/, (_, p1, y) => `${p1}20${y}`))
            : prospectiveEnd;
    
          if (compareDate(concreteFrom, concreteEnd)) {
            localErr.push({
              field: 'fromDate>endDate',
                message: END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT
                  .replace('End Date', 'To Date/Quarter')
                  .replace('Start Date', 'From Date/Quarter')
            });
          }
        }
      }
    
      
      if (!localErr.some(e => e.field === 'startQtr')) {
        setValidatedStartQtr(startQtr);
      }
    
      // De-duplicate by field + message
      const dedup = [];
      const seen = new Set();
      localErr.forEach(e => {
        const key = `${e.field}|${e.message}`;
        if (!seen.has(key)) {
          seen.add(key);
          dedup.push(e);
        }
      });
    
      dispatch(dispatchErrorMsgUnit(dedup));
    }; 
  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/unitAdjustmentatNdcLevel', true);
    } else {
      tabHighLigther('/unitAdjustmentatNdcLevel', false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // dispatch all rebate program
  React.useEffect(() => {
    const startQtrError = validateStartQuarterOnly(
      'startQtr',
      startQtr,
      'fromUseEffect'
    );

    if (
      reportSelection === 'Paid Quarter' &&
      startQtr !== '' &&
      startQtrError.length === 0 &&
      startQtr.length === 6
    ) {
      dispatch(
        getAllRebateProgram({
          rebateProgramCd: allRebateProgram ? null : state.rebateProgramCd,
          aiAllRpc: allRebateProgram ? 1 : 0,
          paidQtr: startQtr,
        })
      );
    }
  }, [allRebateProgram, state.rebateProgramCd, startQtr]);

  // React.useEffect(() => {
  //   let endDateValue = endDate || fromDate;
  //   if (
  //     reportSelection == 'Adjustment Type/Dates' &&
  //     fromDate.length === 10 &&
  //     endDateValue.length === 10
  //   ) {
  //     dispatch(
  //       getAllRebateProgram({
  //         rebateProgramCd: allRebateProgram ? null : state.rebateProgramCd,
  //         aiAllRpc: allRebateProgram ? 1 : 0,
  //         startDate: fromDate,
  //         endDate: endDate || fromDate,
  //         adjustmentTyep: adjustmentType,
  //       })
  //     );
  //   }
  // }, [
  //   allRebateProgram,
  //   state.rebateProgramCd,
  //   reportSelection,
  //   fromDate,
  //   endDate,
  // ]);

  React.useEffect(() => {
    const data = allRebate?.unitAdjustmentsNDCLevelHeaderReportVO;
    setRebateList(data);
  }, [allRebate]);
  
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgUnit([]));
  }, [allRebateProgram, state.planTypeCd, state.rebateProgramCd, reportSelection, startQtr, adjustmentType ]);

  

  if (
    isSearchClicked &&
    gridData?.unitAdjustmentsNDCLevelGridReportVOList?.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/displayUnitAdjustmentatNdcLevel',

      value: 'Display Unit Adjustments at NDC Level',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/displayUnitAdjustmentatNdcLevel',
    });
    dispatch(clearReduxForFilterAndSort('/displayUnitAdjustmentatNdcLevel'));
  }

  // setting Quarter From
  const handlefromChange = (event) => {
    let { value } = event.target;
    if (value?.includes('q')) {
      value = value?.replace('q', 'Q');
    }
    setStartQtr(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgUnit(unique));
  };

  // setting begin date
  const handleBeginChange = (event) => {
    const date = event.target.value;
    const parts = date.split('/');
    let formattedDate;
    // Check if the entered date has the required format
    if (
      parts.length === 3 &&
      parts[0].length === 1 &&
      parts[1].length === 1 &&
      parts[2].length === 2
    ) {
      // Convert to mm/dd/yyyy format
      const [month, day, year] = parts;
      formattedDate = `${month.padStart(2, '0')}/${day.padStart(
        2,
        '0'
      )}/${`20${year}`}`;
    } else {
      // Use the entered date as is
      formattedDate = date;
    }
    setFromDate(formattedDate);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'fromDate');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgUnit(unique));
  };

  // setting end date
  const handleEndChange = (event) => {
    const dateEnd = event.target.value;
    const parts = dateEnd.split('/');
    let formattedDateEnd;
    // Check if the entered date has the required format
    if (
      parts.length === 3 &&
      parts[0].length === 1 &&
      parts[1].length === 1 &&
      parts[2].length === 2
    ) {
      // Convert to mm/dd/yyyy format
      const [month, day, year] = parts;
      formattedDateEnd = `${month.padStart(2, '0')}/${day.padStart(
        2,
        '0'
      )}/${`20${year}`}`;
    } else {
      // Use the entered date as is
      formattedDateEnd = dateEnd;
    }
    setEndDate(formattedDateEnd);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter(
      ((item) => item.field !== 'endDate') &&
        ((item) => item.field !== 'fromDate>endDate')
    );
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgUnit(unique));
  };

  return (
    <div
      className="tabs-container  tBillPanel custom-check"
      data-testid="program-and-eligibility"
    >
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Unit Adjustments at NDC level"
      />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}
      <div className="tab-body custom-search-dates">
        <div className="row ml-2 mb-3 ">
          <div className="col-4 ">
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={allRebateProgram}
                  name="allRebateProgram"
                  // onBlur={() => {}}
                  onChange={() => {
                    setAllRebateProgram(!allRebateProgram);

                    const tempRadioList = radioList.map((item) => {
                      return { ...item, disabled: !allRebateProgram };
                    });
                    setRadioList(tempRadioList);
                    let localErr = getErrorMsg || [];
                    localErr = localErr.filter(
                      (item) => item.field !== 'rebateProgramCd'
                    );
                    const unique = [...new Set(localErr)];
                    dispatch(dispatchErrorMsgUnit(unique));
                  }}
                />
              }
              label="All Rebate Programs"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              disabled
              data-testid="req-fltr-plan"
              id="radio-button-for-rcdd_id"
              labelName="Plan Type"
              required={false}
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program<span className="mandatory">*</span>
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    disabled={allRebateProgram}
                    name="rebateProgram"
                    id="rebate_program"
                    data-testid="req-unit-adj-reb"
                    label="Rebate Program"
                    fullWidth
                    select
                    required
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    value={
                      state && state.rebateProgramCd
                        ? state.rebateProgramCd
                        : ''
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-sm-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">Report Selection</legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <RadioGroup
                    row
                    data-testid="req-qtr"
                    name="report-quarter"
                    required
                    value={reportSelection}
                    onChange={(e) => {
                      setReportSelection(e.target.value);
                      let localErr = getErrorMsg || [];
                      localErr = localErr.filter(
                        (item) => item.field !== 'fromDate'
                      );
                      localErr = localErr.filter(
                        (item) => item.field !== 'startQtr'
                      );
                      const unique = [...new Set(localErr)];
                      dispatch(dispatchErrorMsgUnit(unique));
                    }}
                  >
                    <FormControlLabel
                      style={{ marginRight: '10px' }}
                      value="Paid Quarter"
                      control={<Radio />}
                      label="Paid Quarter"
                    />
                    <FormControlLabel
                      style={{ marginRight: '10px' }}
                      value="Adjustment Type/Dates"
                      control={<Radio />}
                      label="Adjustment Types/Dates"
                    />
                  </RadioGroup>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div className="row">
          {reportSelection == 'Paid Quarter' && (
            <div className="col-4 frr-two-col-radio">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter<span className="mandatory">*</span>
                </legend>
                <div className="form-wrapper p-3">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      id="check_by_invoice_quater"
                      label="Quarter_Number"
                      data-testid="req-unit-adj-qtr"
                      required
                      fullWidth
                      value={startQtr}
                      onChange={handlefromChange}
                      placeholder=""
                      inputProps={{
                        maxLength: 6,
                        id: 'check_by_invoice_quater',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name="startQtr"
                      className={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'startQtr'
                                ? 'mandate-fields frr-display-hidden-label'
                                : 'frr-display-hidden-label'
                            )
                          : 'frr-display-hidden-label'
                      }
                      onBlur={(e) =>
                        handleOnblurEvent('startQtr', e.target.value)
                      }
                      helperText={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field === 'startQtr' ? l.message : null
                            )
                          : null
                      }
                      error={
                        getErrorMsg?.length > 0
                          ? _.map(getErrorMsg, (l) =>
                              l.field == 'startQtr' ? l.message : null
                            )
                          : null
                      }
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          )}
          {reportSelection == 'Adjustment Type/Dates' && (
       <div className="col-sm-4">
          <fieldset className="custom-fieldset date-quarter-range-unitAdjus">
            <legend className="same-font-family">
              Date/Quarter Range <span className="mandatory"> *</span>
            </legend>
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="From Date/Quarter"
                      id="ua-from-date-quarter"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10 }}
                      name="fromDate"
                      value={fromDate}
                      data-testid="unitAdjustment-fromDateQuarter"
                      className="mandate-fields"
                      error={
                        getErrorMsg.filter(e => e.field === 'fromDate').length > 0
                      }
                      helperText={getErrorMsg
                        .find(e => e.field === 'fromDate')
                        ?.message
                        ?.replace('date', 'From Date/Quarter')
                        ?.replace('As Of Date', 'From Date/Quarter')}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        dispatch(
                          dispatchErrorMsgUnit(
                            getErrorMsg.filter(er => er.field !== 'fromDate')
                          )
                        );
                      }}
                      onBlur={(e) => handleOnblurEvent('fromDate', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="To Date/Quarter"
                      id="ua-to-date-quarter"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10 }}
                      name="endDate"
                      value={endDate}
                      data-testid="unitAdjustment-toDateQuarter"
                      className="mandate-fields"
                      error={
                        getErrorMsg.filter(
                          e =>
                            e.field === 'endDate' ||
                            e.field === 'fromDate>endDate'
                        ).length > 0
                      }
                      helperText={getErrorMsg
                        .find(
                          e =>
                            e.field === 'endDate' ||
                            e.field === 'fromDate>endDate'
                        )
                        ?.message
                        ?.replace('date', 'To Date/Quarter')
                        ?.replace('As Of Date', 'To Date/Quarter')}
                      onChange={(e) => {
                        setEndDate(e.target.value.toUpperCase());
                        dispatch(
                          dispatchErrorMsgUnit(
                            getErrorMsg.filter(
                              er =>
                                !['endDate', 'fromDate>endDate'].includes(er.field)
                            )
                          )
                        );
                      }}
                      onBlur={(e) => handleOnblurEvent('endDate', e.target.value)}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </fieldset>
        </div>
          )}
          {reportSelection == 'Adjustment Type/Dates' && (
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="req-fltr-all"
                id="radio-button-for-rcdd_id"
                labelName="Adjustment Type"
                required={false}
                optionList={[
                  {
                    name: 'ALL',
                    value: 'ALL',
                  },
                  {
                    name: 'Unit',
                    value: 'Unit',
                  },
                  {
                    name: 'Rate',
                    value: 'Rate',
                  },
                  {
                    name: 'Write Off',
                    value: 'Write Off',
                  },
                ]}
                defaultValue={adjustmentType}
                filterAction={(value) => {
                  setAdjustmentType(value);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
          )}
        </div>

        <div className="col-12 btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print">
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={onClickOnSearch}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitAdjustment;
